export const htmlDecoder = (htmlElement: string, doubleDecode: boolean) => {
    // Set the innerHTML twice to remove encoded HTML from description
    const div = document.createElement("div");
    div.innerHTML = htmlElement;
    if (doubleDecode) {
        return htmlDecoder(div.innerText, false);
    }
    return div.innerText;
};
